import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from '../dropdown/dropdown.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddCostComponent } from './add-cost.component';
import { EnterPressDirective } from '../directives/enter-press.directive';
import { OpsNumberDirective } from '../directives/ops-number.directive';
import { OpsCalendarComponent } from '@ops/storybook';
import { TranslateModule } from '@ngx-translate/core';
import { BankAccountCreateModalComponent } from '../bank-account-create-modal/bank-account-create-modal.component';
import { CreditCardCreateModalComponent } from '../credit-card-create-modal/credit-card-create-modal.component';
import { OpsCustomCurrencyModalComponent } from '@ops/storybook';
import { NumericInputComponent } from '../numeric-input/numeric-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    EnterPressDirective,
    OpsNumberDirective,
    OpsCalendarComponent,
    TranslateModule,
    BankAccountCreateModalComponent,
    CreditCardCreateModalComponent,
    OpsCustomCurrencyModalComponent,
    NumericInputComponent,
  ],
  exports: [AddCostComponent],
  declarations: [AddCostComponent],
})
export class AddCostModule {}
